import usaMap from "../../../assets/images/Maps/USA_map.svg";
import CEMEA from "../../../assets/images/Maps/CEMEA.svg";
import asiaPacificMap from "../../../assets/images/Maps/AP_map.svg";
import latinAmericaMap from "../../../assets/images/Maps/LAC_map.svg";
import euMap from "../../../assets/images/Maps/EU_map.svg";
import otherMap from "../../../assets/images/Maps/Other_map.svg";


export const geographical_Region_Selection = [
  { label: "United States (US)", value: "United States (US)", img: usaMap },
  { label: "Central Europe, Middle East, and Africa (CEMEA)", value: "Central Europe, Middle East, and Africa (CEMEA)", img: CEMEA },
  { label: "Asia-Pacific (AP)", value: "Asia-Pacific (AP)", img: asiaPacificMap },
  { label: "Latin America and the Caribbean (LAC)", value: "Latin America and the Caribbean (LAC)", img: latinAmericaMap },
  { label: "European Union (EU)", value: "European Union (EU)", img: euMap },
  { label: "Other", value: "Other", img: otherMap },
];
